import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "../../../store/userSlice";
import { setActiveBranch, clearActiveBranch, setAllBranchSettings } from "../../../store/businessSlice";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../api/axiosInstance";
import { baseurl } from "../../../Baseurl";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import BranchSelectorModal from "./BranchSelectorModal";
export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [civilIdNumber, setCivilIdNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [forgotPasswordErrors, setForgotPasswordErrors] = useState({});
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [userId, setUserId] = useState("");
  const [logo, setLogo] = useState(null);
  const [showBranchSelector, setShowBranchSelector] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const validate = () => {
    const newErrors = {};
    if (!civilIdNumber) {
      newErrors.civilIdNumber = "Email or Civil ID is required";
    }
    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const validateForgotPassword = () => {
    const newErrors = {};
    if (currentStep === 1) {
      if (!forgotEmail) {
        newErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(forgotEmail)) {
        newErrors.email = "Email is invalid";
      }
    } else if (currentStep === 2) {
      if (!otp) {
        newErrors.otp = "OTP is required";
      } else if (otp.length !== 6) {
        newErrors.otp = "OTP must be 6 digits";
      }
    } else if (currentStep === 3) {
      if (!newPassword) {
        newErrors.newPassword = "New Password is required";
      } else if (newPassword.length < 6) {
        newErrors.newPassword = "Password must be at least 6 characters";
      }
      if (!confirmNewPassword) {
        newErrors.confirmNewPassword = "Confirm Password is required";
      } else if (newPassword !== confirmNewPassword) {
        newErrors.confirmNewPassword = "Passwords do not match";
      }
    }
    setForgotPasswordErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleGenerateOtp = async () => {
    if (validateForgotPassword()) {
      setForgotPasswordLoading(true);
      try {
        const requestData = {
          email: forgotEmail,
        };
        const response = await axios.post(
          `${baseurl}userOtpGenerate`,
          requestData
        );
        if (response.status === 200) {
          Swal.fire("Success", "OTP sent to your email!", "success");
          setOtpSent(true);
          setCurrentStep(2);
          setForgotPasswordErrors({});
        }
      } catch (error) {
        console.error("OTP generation failed:", error);
        Swal.fire(
          "Error",
          error.response?.data?.message || "Failed to send OTP",
          "error"
        );
      } finally {
        setForgotPasswordLoading(false);
      }
    }
  };
  const handleVerifyOtp = async () => {
    if (validateForgotPassword()) {
      setForgotPasswordLoading(true);
      try {
        const requestData = {
          otp: otp,
        };
        const response = await axios.post(
          `${baseurl}userVerifyOtp`,
          requestData
        );
        if (response.status === 200) {
          if (response.data.data) {
            setUserId(response.data.data);
          } else if (response.data.user && response.data.user.id) {
            setUserId(response.data.user.id);
          } else if (response.data.id) {
            setUserId(response.data.id);
          }
          Swal.fire("Success", "OTP verified successfully!", "success");
          setCurrentStep(3);
          setForgotPasswordErrors({});
        }
      } catch (error) {
        console.error("OTP verification failed:", error);
        Swal.fire(
          "Error",
          error.response?.data?.message || "Invalid OTP",
          "error"
        );
      } finally {
        setForgotPasswordLoading(false);
      }
    }
  };

  const fetchLogo = () => {
    axiosInstance.get(
      `getLogo`
    ).then(response => {
      try {
        if (response.data.logo && response.data.logo != null) {
          setLogo(response.data.logo)
        } else {
          setLogo("logo512.png")
        }
      } catch (e) {
        setLogo("logo512.png")
      }
    }).catch(e => {
      setLogo("logo512.png")
    })
  }

  useEffect(() => {
    fetchLogo()
  })
  const handleResetPassword = async () => {
    if (validateForgotPassword()) {
      setForgotPasswordLoading(true);
      try {
        const requestData = {
          newPassword: newPassword,
          confirmNewPassword: confirmNewPassword,
        };
        const endpoint = userId
          ? `${baseurl}userResetPassword/${userId}`
          : `${baseurl}userResetPassword`;
        const response = await axios.post(endpoint, requestData);
        if (response.status === 200) {
          Swal.fire("Success", "Password reset successfully!", "success");
          setShowForgotPasswordModal(false);
          setForgotEmail("");
          setOtp("");
          setNewPassword("");
          setConfirmNewPassword("");
          setForgotPasswordErrors({});
          setOtpSent(false);
          setCurrentStep(1);
          setUserId("");
        }
      } catch (error) {
        console.error("Password reset failed:", error);
        Swal.fire(
          "Error",
          error.response?.data?.message || "Failed to reset password",
          "error"
        );
      } finally {
        setForgotPasswordLoading(false);
      }
    }
  };
  const startAutoLogoutTimer = () => {
    let logoutTimer;
    const stored = JSON.parse(localStorage.getItem("businessSetting") || "{}")
    const minutes = parseInt(stored?.auto_logout_minutes || 30, 10);
    const resetTimer = () => {
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(() => {
        Swal.fire(
          "Session Expired",
          `You have been logged out automatically after ${minutes} minutes of inactivity.`,
          "warning"
        ).then(() => {
          localStorage.removeItem("userMedical");
          localStorage.removeItem("userName");
          localStorage.removeItem("activeBranchId");
          localStorage.removeItem("activeBranchSettings");
          dispatch(clearActiveBranch());
          navigate("/");
          window.location.reload();
        });
      }, minutes * 60 * 1000);
    };
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("scroll", resetTimer);
    window.addEventListener("click", resetTimer);
    resetTimer();
    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      window.removeEventListener("click", resetTimer);
      clearTimeout(logoutTimer);
    };
  };
  const handleClick = async () => {
    if (validate()) {
      setLoading(true);
      const userData = {
        civilIdNumber: civilIdNumber,
        password: password,
      };
      try {
        const response = await axios.post(`${baseurl}userLogin`, userData);
        if (response.status === 200 && response.data.success) {
          toast.success("Login successful");
          const res = response.data;
          const userObj = res.data;
          const selectedDoctors = res.selectedDoctors || [];
          const businessSetting = res.businessSetting || {};
          const permissions = res.permissions || []; // Get permissions from response
          const token = res.token;
          localStorage.setItem("id", userObj.id);
          localStorage.setItem("token", token);
          localStorage.setItem("userMedical", JSON.stringify({ data: userObj }));
          localStorage.setItem("userarray", JSON.stringify({ data: selectedDoctors }));
          localStorage.setItem("businessSetting", JSON.stringify(businessSetting));
          localStorage.setItem("userPermissions", JSON.stringify(permissions)); // Save permissions
          if (businessSetting?.image) {
            localStorage.setItem("businessSettingImage", businessSetting.image);
          }
          const displayName =
            userObj?.name || userObj?.fullName || userObj?.email || "";
          if (displayName) localStorage.setItem("userName", displayName);
          if (userObj?.personalPhoto) {
            localStorage.setItem("userPersonalPhoto", String(userObj.personalPhoto));
          }
          localStorage.setItem("profilePhotoBust", String(Date.now()));
          try {
            window.dispatchEvent(new CustomEvent("profile-updated"));
          } catch { }
          dispatch(setUser(userObj));
          startAutoLogoutTimer();

          // Fetch all branch settings to determine branch selector
          try {
            const doctorId = userObj?.id || userObj?.doctor_id;
            const branchRes = await axiosInstance.get(`getAllBranchSettings/${doctorId}`);
            const branches = branchRes.data?.data || [];
            dispatch(setAllBranchSettings(branches));
            if (branches.length <= 1) {
              // Single branch — auto-set and proceed
              const singleBranch = branches[0] || businessSetting;
              if (singleBranch) dispatch(setActiveBranch(singleBranch));
              Swal.fire("Success!!", "Admin Login Successfully.", "success");
              navigate("/Homepage");
            } else {
              // Multiple branches — show selector, navigate after selection
              setBranchList(branches);
              setShowBranchSelector(true);
              setLoading(false);
            }
          } catch {
            // Fallback: proceed without branch selector
            dispatch(setActiveBranch(businessSetting));
            Swal.fire("Success!!", "Admin Login Successfully.", "success");
            navigate("/Homepage");
          }
        } else {
          toast.error("Invalid login response");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Login failed");
        console.error("Login failed:", error.response?.data?.message || error.message);
      } finally {
        setLoading(false);
      }
    } else {
      console.error("Validation failed");
    }
  };
  const handleBranchSelect = (branch) => {
    setShowBranchSelector(false);
    Swal.fire("Success!!", "Admin Login Successfully.", "success");
    navigate("/Homepage");
  };

  return (
    <>
    {showBranchSelector && (
      <BranchSelectorModal branches={branchList} onSelect={handleBranchSelect} />
    )}
    <div className="loginMainVideo">
      <video autoPlay muted loop playsInline>
        <source src="/homeVideo.mp4" type="video/mp4" />
      </video>
      <div className="mainLogin">
        <div className="container loginBgColor">
          <div className="login-box mx-auto bg-white">
            <div className="text-center">
              {logo !== null && <img
                src={logo}
                alt="Logo"
                className="logo-image mb-2"
                style={{ width: "139px" }}
              />}

            </div>
            <h4 className="login-title">Login</h4>
            <div className="mb-3">
              <label className="form-label">Civil ID</label>
              <input
                type="text"
                className="form-control bg-light"
                placeholder="Enter civil ID"
                value={civilIdNumber}
                onChange={(e) => setCivilIdNumber(e.target.value)}
              />
              {errors.civilIdNumber && (
                <small className="text-danger">{errors.civilIdNumber}</small>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control bg-light"
                  placeholder="••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleClick()}
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <VisibilityOffIcon /> : "👁"}
                </button>
              </div>
              {errors.password && (
                <small className="text-danger">{errors.password}</small>
              )}
            </div>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <label
                  htmlFor="remember"
                  className="form-check-label d-flex align-items-center gap-2"
                >
                  <input type="checkbox" id="remember" />
                  Keep me sign in
                </label>
              </div>
              <a
                href="#"
                className="small"
                onClick={(e) => {
                  e.preventDefault();
                  setShowForgotPasswordModal(true);
                }}
              >
                Forgot Password?
              </a>
            </div>
            <button
              className="btn btn-primary w-100"
              onClick={handleClick}
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </div>
          <ToastContainer />
        </div>
        {showForgotPasswordModal && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {currentStep === 1 && "Reset Password"}
                    {currentStep === 2 && "Otp Verification"}
                    {currentStep === 3 && "Set New Password"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowForgotPasswordModal(false);
                      setCurrentStep(1);
                      setForgotEmail("");
                      setOtp("");
                      setNewPassword("");
                      setConfirmNewPassword("");
                      setForgotPasswordErrors({});
                      setOtpSent(false);
                      setUserId("");
                    }}
                  ></button>
                </div>
                <div className="modal-body">
                  {currentStep === 1 && (
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email address"
                        value={forgotEmail}
                        onChange={(e) => setForgotEmail(e.target.value)}
                      />
                      {forgotPasswordErrors.email && (
                        <small className="text-danger">
                          {forgotPasswordErrors.email}
                        </small>
                      )}
                    </div>
                  )}
                  {currentStep === 2 && (
                    <div className="mb-3">
                      <label className="form-label">Enter OTP</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter 6-digit OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        maxLength="6"
                      />
                      {forgotPasswordErrors.otp && (
                        <small className="text-danger">
                          {forgotPasswordErrors.otp}
                        </small>
                      )}
                      <small className="text-muted">
                        OTP has been sent to {forgotEmail}
                      </small>
                    </div>
                  )}
                  {currentStep === 3 && (
                    <>
                      <div className="mb-3">
                        <label className="form-label">New Password</label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter new password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        {forgotPasswordErrors.newPassword && (
                          <small className="text-danger">
                            {forgotPasswordErrors.newPassword}
                          </small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Confirm New Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Confirm new password"
                          value={confirmNewPassword}
                          onChange={(e) =>
                            setConfirmNewPassword(e.target.value)
                          }
                        />
                        {forgotPasswordErrors.confirmNewPassword && (
                          <small className="text-danger">
                            {forgotPasswordErrors.confirmNewPassword}
                          </small>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowForgotPasswordModal(false);
                      setCurrentStep(1);
                      setForgotEmail("");
                      setOtp("");
                      setNewPassword("");
                      setConfirmNewPassword("");
                      setForgotPasswordErrors({});
                      setOtpSent(false);
                      setUserId("");
                    }}
                  >
                    Cancel
                  </button>
                  {currentStep === 1 && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleGenerateOtp}
                      disabled={forgotPasswordLoading}
                    >
                      {forgotPasswordLoading ? "Sending..." : "Send OTP"}
                    </button>
                  )}
                  {currentStep === 2 && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleVerifyOtp}
                      disabled={forgotPasswordLoading}
                    >
                      {forgotPasswordLoading ? "Verifying..." : "Verify OTP"}
                    </button>
                  )}
                  {currentStep === 3 && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleResetPassword}
                      disabled={forgotPasswordLoading}
                    >
                      {forgotPasswordLoading
                        ? "Resetting..."
                        : "Reset Password"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    </>
  );
}
